import React from "react";

const AddOrder = () => {
  return <div>AddOrder</div>;
};

export default AddOrder;
